import { render, staticRenderFns } from "./insurance_payment.vue?vue&type=template&id=500bcabd&scoped=true&"
import script from "./insurance_payment.vue?vue&type=script&lang=js&"
export * from "./insurance_payment.vue?vue&type=script&lang=js&"
import style0 from "./insurance_payment.vue?vue&type=style&index=0&id=500bcabd&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500bcabd",
  null
  
)

export default component.exports